import React from 'react'
import Tag from '../tag'
import { DATA_SET_CODE_SEPARATOR, DATA_SET_LEVEL_SEPARATOR } from '../../constants/dataSets'

const KeyValuePair = ({ keyName, value, children, type = "", withColon = true, highlightedKeyName }) => {
  return (
    <div className={`bimmatch-key-value-pair ${React.isValidElement(children) ? "custom" : type}-property-value-wrapper`}>
      {
        type === "hierarchy" ? (
          <HierarchyKeyValueField keyName={keyName} value={value} highlightedKeyName={highlightedKeyName} />
        ) : (
          <>
              <KeyField type={type} keyName={keyName} withColon={withColon} />
              {!!children ? children : <ValueField type={type} value={value} />}
          </>
        )
      }
    </div>
  )
}

const KeyField = ({ type, keyName, withColon, highlightedKeyName }) => {
  return <span className={`key-field value-field-${type}`}>{keyName}{highlightedKeyName ? (<span className='highlighted-key-name' dir='auto'>{highlightedKeyName}</span>) : (<></>)}{withColon ? ":" : ""}</span>
}

const ValueField = ({ type, value }) => {
  switch (type) {
    case "tags":
      return (
        <div className='tags-wrapper' dir='auto'>
          {value.map(tagData => <Tag key={tagData.id} name={tagData.displayName} color={tagData?.color || null} />)}
        </div>
      )
    case "data-set":
      return (
        <div className='value-field value-field-data-set'>
          {value.split(DATA_SET_LEVEL_SEPARATOR).map(level => {
            const [code, description] = level.split(DATA_SET_CODE_SEPARATOR)
            return <p key={code} dir='auto'><span className='data-set-code'>{code}</span> {description}</p>
          })}
        </div>
      )
    default:
      return (
        <span className={`value-field value-field-${type}`} dir='auto'>{formatValue(type, value)}</span>
      )
  }
}

export const HierarchyKeyValueField = ({ keyName, value = {}, highlightedKeyName }) => {
  return (
    <div className='hierarchy-key-value-field'>
      <KeyField keyName={keyName} withColon={false} type={"hierarchy"} highlightedKeyName={highlightedKeyName} />
      <div className='hierarchy-value-field'>
        {Object.values(value).map(childData => (
          <KeyValuePair key={childData.key} keyName={childData.keyName} value={childData.value} type={childData.type} />
        ))}
      </div>
    </div>
  )
}

const formatValue = (type, value) => {
  switch (type) {
    case "array":
      return value.join(", ");
    case "boolean":
      return value ? "Yes" : "No"
    default:
      return ((typeof value === "string") ? value : JSON.stringify(value))
  }
}

export default KeyValuePair